// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + "actioncable" + "-" + "36b8a0a98475c77e" + ".chunk.js"
}